var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Http from "axios";
import GoogleMapStyles from "@app/global/googleMapStyles";
import googleMapsLoader from "load-google-maps-api";
import { EventTracking, EventType } from '@app/tracking';
export default Vue.extend({
    data: function () { return ({
        loading: false,
        locations: {
            initial: Array(),
            filtered: Array(),
            active: null
        },
        searchInput: null,
        searchResult: null,
        map: undefined,
        googleMaps: null,
        maxRadius: 50000,
        services: {
            Map: null,
            Geocoder: null
        }
    }); },
    mounted: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchData()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initApi()];
                    case 2:
                        _a.sent();
                        if (this.$refs.map) {
                            this.initMap();
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: {
        initApi: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, googleMapsLoader({
                            key: window.GMAPS_API_KEY,
                            libraries: ["geometry"]
                        }).then(function (googleMaps) {
                            _this.googleMaps = googleMaps;
                            _this.services.Map = googleMaps.Map;
                            _this.services.Geocoder = googleMaps.Geocoder;
                        })];
                });
            });
        },
        initMap: function () {
            var mapOptions = {
                disableDefaultUI: true,
                styles: GoogleMapStyles
            };
            this.map = new this.googleMaps.Map(this.$refs.map, mapOptions);
            this.setupMarkers(this.locations.initial);
        },
        fetchData: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this.loading = true;
                    return [2 /*return*/, Http.get("/api/locator/location").then(function (res) {
                            _this.locations.initial = res.data;
                            _this.loading = false;
                        })];
                });
            });
        },
        search: function () {
            var _this = this;
            var geocoder = new this.googleMaps.Geocoder();
            this.loading = true;
            geocoder.geocode({
                address: this.searchInput || "",
                componentRestrictions: { country: "ch" }
            }, function (result, status) {
                if (status.toString() === "OK" && result.length > 0) {
                    var bestResult = result[0];
                    _this.showResults(bestResult);
                }
                else {
                    _this.locations.filtered = [];
                    _this.setMapBounds(_this.locations.initial);
                }
                _this.loading = false;
            });
            EventTracking.dispatch(EventType.LocatorSearch, {
                searchQuery: this.searchInput || ''
            });
        },
        showResults: function (geocodedResult) {
            var _this = this;
            this.searchResult = geocodedResult;
            this.searchInput = geocodedResult.formatted_address;
            this.locations.initial = this.locations.initial.map(function (location) {
                location.distanceToResult = Math.round(_this.googleMaps.geometry.spherical.computeDistanceBetween(geocodedResult.geometry.location, new _this.googleMaps.LatLng(location.lat, location.lng)));
                return location;
            });
            this.locations.filtered = this.locations.initial.filter(function (location) { return location.distanceToResult <= _this.maxRadius; });
            if (this.locations.filtered.length > 0) {
                this.locations.filtered.sort(function (a, b) { return a.distanceToResult - b.distanceToResult; });
                this.locations.filtered = this.locations.filtered.slice(0, 5);
                this.setMapBounds(this.locations.filtered);
            }
        },
        setupMarkers: function (locations) {
            var _this = this;
            locations.forEach(function (location) {
                var marker = new _this.googleMaps.Marker({
                    map: _this.map,
                    position: {
                        lat: location.lat,
                        lng: location.lng
                    },
                    icon: new _this.googleMaps.MarkerImage("/images/icons/map-marker-alt-light.svg", new _this.googleMaps.Size(40, 40), new _this.googleMaps.Point(0, 0), new _this.googleMaps.Point(20, 40), new _this.googleMaps.Size(40, 40))
                });
                var infoWindow = new _this.googleMaps.InfoWindow({
                    content: "\n                        <strong>".concat(location.name, "</strong><br>\n                        ").concat(location.street, "<br>\n                        ").concat(location.zip, " ").concat(location.city, "<br>\n                        ").concat(location.country || "", "\n                    ")
                });
                marker.addListener("click", function (e) {
                    infoWindow.open(_this.map, marker);
                    _this.setActiveLocation(location);
                });
            });
            this.setMapBounds(locations);
        },
        setMapBounds: function (locations) {
            if (this.map) {
                var bounds_1 = new this.googleMaps.LatLngBounds();
                locations.forEach(function (location) {
                    return bounds_1.extend({ lat: location.lat, lng: location.lng });
                });
                this.map.fitBounds(bounds_1);
            }
        },
        setActiveLocation: function (location) {
            if (this.locations.active == location) {
                location = null;
            }
            this.locations.active = location;
            if (this.map) {
                if (location) {
                    this.map.panTo({ lat: location.lat, lng: location.lng });
                    this.map.setZoom(15);
                }
                else {
                    this.setMapBounds(this.locations.filtered);
                }
            }
        },
        buildGoogleMapsLink: function (location) {
            return "https://maps.google.com?q=".concat(location.street, ", ").concat(location.zip, " ").concat(location.city, ", ").concat(location.country || "");
        },
        sendTrackingEvent: function (category, action, label) {
            if (label === void 0) { label = ""; }
            EventTracking.dispatch(EventType.Track, {
                category: category,
                action: action,
                label: label
            });
        }
    }
});
